"use client";

// Wrapper minimal de react-markdown com remark-gfm. Usado para renderizar
// conteúdo cadastrado pelo admin no CMS (vagas, requisitos, termos legais).
// Aplica classe `prose-md` pra estilização local no globals.css.

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function Markdown({ source, className }) {
  const text = typeof source === "string" ? source : "";
  if (!text) return null;
  return (
    <div className={["prose-md", className].filter(Boolean).join(" ")}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // react-markdown passa `node` (a AST) junto com os props do
          // elemento. O React 19 não avisa sobre atributo desconhecido, só
          // cospe node="[object Object]" no HTML — daí o descarte.
          a: ({ node, ...props }) => (
            <a {...props} target={props.href?.startsWith("http") ? "_blank" : undefined} rel={props.href?.startsWith("http") ? "noopener noreferrer" : undefined} />
          ),
          // Tabela GFM do CMS não cabe na coluna de texto no mobile e
          // html/body são `overflow-x: clip` — sem este wrapper as colunas
          // da direita são cortadas sem scroll nenhum. `tabIndex` dá acesso
          // por teclado ao scroll horizontal.
          table: ({ node, ...props }) => (
            <div className="prose-md-scroll" tabIndex={0}>
              <table {...props} />
            </div>
          ),
          // Imagem do CMS vem em tamanho original e sempre abaixo da dobra
          // (o conteúdo começa com texto), então lazy + async não custa nada.
          img: ({ node, alt, ...props }) => (
            <img {...props} alt={alt ?? ""} loading="lazy" decoding="async" />
          ),
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
